import {filter, map, Observable, pipe, UnaryFunction} from 'rxjs';
import {WebSocketParsed, WebSocketResponse} from '@tisa-group/models';
import {Jsona} from 'jsona';

export function parseWebSocketResponse<T>(): UnaryFunction<
  Observable<WebSocketResponse<T>>,
  Observable<WebSocketParsed<T>>
> {
  return pipe(
    filter(res => Boolean(res?.message?.object)),
    map(res => res.message),
    map(res => {
      const jsona = new Jsona();

      return {
        action: res.action,
        data: jsona.deserialize(res.object as any, {}) as T,
      };
    }),
  );
}
